@if (hasError) {
  <app-error-strip
    [popup]="true"
    i18n="
      XMSG|An error that is displayed when failed to retrieve
      organizations@@organizations.errors.retrievalFailed"
    [errorText]="'Could not fetch existing organizations from the server; please try again later.'"
  ></app-error-strip>
}
<app-panel-header
  (doSearch)="doSearch($event)"
  [isLiveSearch]="!isPaginatedView"
  [glyph]="ResourceType.ORGANIZATION | resourceGlyph"
  text="Organizations"
  [advancedSearchOpen]="advancedSearchOpen"
  [advancedSearchReady]="advancedSearchReady"
  [resultCount]="resourceContent?.items?.length || 0"
  [filterViewName]="currentFilterViewName"
  [organizationPath]="getOrganizationPath()"
  [savedFilterViewsDisabled]="isFclOpen"
  (viewSelected)="onSavedViewSelected($event)"
  (advancedSearchToggled)="onAdvancedSearchToggled($event)"
  [body]="headerBody"
></app-panel-header>

<ng-template #headerBody>
  <fd-toolbar-spacer></fd-toolbar-spacer>
  @if (!advancedSearchOpen) {
    <button
      fd-button
      id="refresh-button"
      fdType="transparent"
      (click)="resourceContent.loadContent(true)"
      [disabled]="resourceContent.loading"
    >
      <app-icon icon="rotate-right" size="lg" [fixedWidth]="true"></app-icon>
    </button>
  }
  @if (!advancedSearchOpen) {
    <app-reset-filter-btn
      [disableClearFilter]="!resourceContent?.dataTable?.hasFilter"
      (resetFilter)="resourceContent.reset()"
    ></app-reset-filter-btn>
  }
  <app-table-personalization
    [disabled]="isFclOpen"
    [tableKey]="currentTableKey"
  ></app-table-personalization>
  @if (advancedSearchOpen) {
    <button
      fd-button
      fdType="transparent"
      (click)="onAdvancedSearchToggled(false)"
      title="Close Advanced Search"
    >
      <app-icon icon="times"></app-icon>
    </button>
  }
</ng-template>
<app-organization-content
  #resourceContent
  [selectedProject]="selectedProject"
  [(isPaginatedView)]="isPaginatedView"
  (toggleFclMain)="toggleFcl($event)"
  (errorEvent)="error = $event"
  [advancedSearchTerms]="advancedSearchTerms"
  [advancedSearchOpen]="advancedSearchOpen"
  [availableResourceTypes]="availableResourceTypes"
  [currentFilterViewName]="currentFilterViewName"
  (advancedSearchToggled)="onAdvancedSearchToggled($event)"
  (viewSaved)="onViewSaved($event)"
  (filtersChanged)="onFiltersChanged()"
  [searchTerm]="searchTerm"
></app-organization-content>
